const FILE_UPLOADER_SUBDIRECTORY = "/fileUploader";

export const uploadAudioFile = `${FILE_UPLOADER_SUBDIRECTORY}/uploadAudioFile`;

export const uploadImageFile = `${FILE_UPLOADER_SUBDIRECTORY}/uploadImage`;
